import { GroundTransportationSearchController } from 'src/common/controllers/ground-transportation/search-controller';
export const groundTransportation = [GroundTransportationSearchController];